import { createContext } from 'react'
import type { BootstrapData } from '@/types'

const BootstrapDataContext = createContext<BootstrapData>({} as BootstrapData)

export default BootstrapDataContext
